import { memo } from 'react';
import { Link, useRouteMatch } from 'react-router-dom';

import { useTutorials } from '~/redux/selectors';
import { tutorialSMappedByPathSelector } from '~/redux/selectors/tutorials';

import { ReactComponent as HelpIcon } from '~/assets/images/iconsLibrary/help.svg';

import styles from './TutorialButton.module.scss';

function TutorialButton() {
  const tutorialsMapped = useTutorials(tutorialSMappedByPathSelector);
  const { path: tutorialMatchedPath } =
    useRouteMatch({
      path: Object.keys(tutorialsMapped),
      exact: true,
    }) || {};

  const tutorialPath = tutorialsMapped[tutorialMatchedPath ?? ''];

  if (!tutorialPath) return null;

  return (
    <Link
      to={tutorialPath ?? '/'}
      className={styles.container}
    >
      <HelpIcon className={styles.icon} />
    </Link>
  );
}

export default memo(TutorialButton);
